/**
 * Splits an editor value into two values, used to break a single text
 * block into multiple for insertion of a new block. It only splits at
 * the root block level.
 *
 * @param {object} value the plain JS object editor value.
 * @param {number} index the index to split
 */
function split(value, index) {
  const nodes = value.document.nodes

  return [
    { document: { nodes: nodes.slice(0, index) } },
    { document: { nodes: nodes.slice(index) } }
  ]
}

export default split
